import { render } from "./presenca-visual-professor.vue?vue&type=template&id=d672a616&scoped=true"
import script from "./presenca-visual-professor.vue?vue&type=script&lang=js"
export * from "./presenca-visual-professor.vue?vue&type=script&lang=js"

import "./presenca-visual-professor.vue?vue&type=style&index=0&id=d672a616&lang=scss&scoped=true"
import "./presenca-visual-professor.vue?vue&type=style&index=1&id=d672a616&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d672a616"]])

export default __exports__